var map = {
	"./bank_1.svg": "560a",
	"./bank_10.svg": "dc88",
	"./bank_11.svg": "d309",
	"./bank_12.svg": "cd62",
	"./bank_13.svg": "6bc7",
	"./bank_14.svg": "cee5",
	"./bank_15.svg": "7db4",
	"./bank_16.svg": "52ef",
	"./bank_17.svg": "681c",
	"./bank_18.svg": "e21a",
	"./bank_19.svg": "b6be",
	"./bank_2.svg": "3f68",
	"./bank_3.svg": "4292",
	"./bank_4.svg": "cd8c",
	"./bank_5.svg": "0bae",
	"./bank_6.svg": "1087",
	"./bank_7.svg": "480e",
	"./bank_8.svg": "3439",
	"./bank_9.svg": "947d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc11";